<template>
  <div class="file-input-box">
    <div v-if="!addressCardano" class="input-not-connected">
      <div class="input-wrap-not-connected">
        <span class="file-input-title"
          >You need to be connected to a wallet</span
        >
        <span class="browse-text">
          <span style="color: white"
            >Sign in before starting the minting process</span
          ></span
        >
        <div class="button-container">
          <app-button
            v-if="!addressCardano"
            buttonClass="app-modal-button-inverse"
            style="width: 210px"
            text="Connect to a wallet"
            @click="loginOrSignUpCardano()"
          />
        </div>
      </div>
    </div>
    <div
      v-else-if="
        !isFileSelected && isValidNetwork && hasSigned && addressCardano
      "
      :class="[
        'file-input',
        state.isDraggedOver && state.overInput ? 'over' : '',
        state.showSpinner ? 'new' : '',
        shouldPickCoverImage ? 'not-image' : '',
      ]"
      @dragenter.prevent=""
      @dragover.prevent="onDragOver"
      @dragleave.prevent="onDragLeave"
      @drop="dropImage"
    >
      <input
        :id="id"
        :name="name"
        v-bind="$attrs"
        type="file"
        @change="onFileChange"
        ref="inputRef"
        :accept="accept"
        hidden
      />
      <label :for="id" style="width: 100%">
        <div
          class="file-input-wrap"
          :class="[
            state.showSpinner ? 'hide' : '',
            isImageOnly ? 'not-image-wrap' : '',
          ]"
        >
          <span>
            <img src="@/Common/Icons/cardano.svg" />
          </span>
          <span class="drag-text">Drag & Drop File</span>
          <span class="browse-text" @click.prevent="onPickFile"
            >or
            <span
              class="browse-underline"
              :class="[isImageOnly ? 'no-image-browse' : '']"
            >
              browse media on your device</span
            ></span
          >
          <div class="file-types">
            <span v-if="isImageOnly"
              >Files type suported: {{ acceptedMimeTypes }}
            </span>
            <span v-else>Files type suported: {{ acceptedMimeTypes }} </span>
            <span>Max size: 40MB</span>
          </div>
        </div>
      </label>
    </div>
    <div
      v-if="!isFileSelected && state.isDraggedOver && state.overInput"
      class="stack-top stack-top-base"
    ></div>
    <div
      class="stack-top stack-top-dim"
      v-if="!isFileSelected && state.isDraggedOver && state.overInput"
    ></div>
    <div
      class="stack-top"
      style="z-index: 3"
      v-if="!isFileSelected && state.isDraggedOver && state.overInput"
    >
      <span class="drag-and-drop-text">Drop File here</span>
    </div>
  </div>
  <file-preview
    v-show="isFileSelected && state.fileType !== 'video'"
    :mimeType="state.mimeType"
    :fileType="state.fileType"
    :url="state.url"
    :hasCoverImage="shouldPickCoverImage"
    :hasError="Boolean(errorMessage)"
    :message="previewMessage"
  />
  <p
    class="input-file-error-message"
    v-show="errorMessage && isValidNetwork && value.name"
  >
    {{ errorMessage }}
  </p>
</template>
<script>
import { useStore } from "vuex";
import AppButton from "./AppButton";
import { useField } from "vee-validate";
import useAuth from "@/composables/useAuth";
import FilePreview from "@/elements/FilePreview";
import { ethereumService, cardanoService, eventBus } from "../main";
import useFileInput from "@/composables/useFileInput";
import useUtilities from "@/composables/useUtilities";
import { computed, reactive, ref, toRef, watch } from "vue";
import useMinting from "../composables/useMinting";

export default {
  name: "FileInput",
  components: {
    FilePreview,
    AppButton,
  },
  props: {
    id: {
      type: String,
    },
    name: {
      type: String,
      default: "",
    },
    modelValue: {
      type: Object,
      default: () => {},
    },
    accept: {
      type: String,
      default: "",
    },
    shouldPickCoverImage: {
      type: Boolean,
      default: false,
    },
    isImageOnly: {
      type: Boolean,
      default: false,
    },
    showPreviewMessage: {
      type: Boolean,
      default: true,
    },
    previewMessagePrefix: {
      type: String,
      default: "YOU WILL TOKENIZE A",
    },
    onChange: {
      type: Function,
    },
  },
  emits: ["update:modelValue"],
  setup(props, context) {
    const store = useStore();
    const { parseAccepted } = useFileInput(store, props);
    const { getFileType, getMimeType } = useUtilities();
    const { loginOrSignUpCardano } = useAuth(
      store,
      ethereumService,
      cardanoService
    );

    // const isValidNetwork = computed(
    //   () => store.getters["contracts/getIsValidNetwork"]
    // );
    const isValidNetwork = true;
    // const hasSigned = computed(() => store.getters["contracts/getHasSigned"]);
    const hasSigned = true;
    const { isBeginConnectionModalOpen } = useMinting(store);

    const initialState = () => ({
      url: "",
      fileType: null, //audio, video, image
      mimeType: "", //jpg, png, webm
      showSpinner: false,
      isDraggedOver: false,
      isOverOthers: false,
      overInput: false,
    });
    const state = reactive(initialState());

    const inputRef = ref("dropFile");
    const dragRef = ref("other");
    const showErrorMessage = ref(true);
    const acceptedMimeTypes = parseAccepted();
    const { value, errorMessage, meta, setErrors } = useField(
      props.name,
      undefined,
      {
        initialValue: props.modelValue,
      }
    );

    watch(meta, (meta) => {
      if (!meta.pending) {
        props.onChange(value.value, meta.valid);
      }
      if (!meta.valid && !meta.dirty) {
        setErrors("");
      }
    });

    if (props.modelValue?.name) {
      value.value = toRef(props.modelValue)._object;
      state.fileType = getFileType(props.modelValue);
      state.mimeType = getMimeType(props.modelValue);
      state.url = URL.createObjectURL(props.modelValue);
    }

    const isFileSelected = computed(() => {
      if (!meta.valid) {
        return false;
      }
      return Boolean(state.url);
    });
    const previewMessage = computed(() => {
      if (!["audio"].includes(state.fileType) && props.showPreviewMessage) {
        return `${props.previewMessagePrefix} ${state.mimeType}`;
      }
      return "";
    });
    const onFileChange = () => {
      const files = inputRef.value.files;
      if (files.length === 0) {
        clearFile();
        return;
      }
      state.showSpinner = true;
      state.mimeType = files[0].type.split("/")[1];
      value.value = files[0];
      state.showSpinner = false;

      state.fileType = value.value.type.split("/")[0];
      state.url = URL.createObjectURL(files[0]);
      showErrorMessage.value = true;
      context.emit("update:modelValue", value.value);
    };
    const clearFile = () => {
      // Clear actual input filed so
      // same file can be added twice in a row
      inputRef.value ? (inputRef.value.value = null) : null;
      const initState = initialState();
      for (const key in initialState()) {
        state[key] = initState[key];
      }
      context.emit("update:modelValue", {});
      value.value = {};
      errorMessage._value = undefined;
    };
    eventBus.on(`clearFile:${props.name}`, clearFile);

    const onDragOver = (e) => {
      if (e.target === dragRef.value) state.isOverOthers = true;
      else {
        state.overInput = true;
        state.isDraggedOver = true;
      }
    };

    const onDragLeave = (e) => {
      if (e.target === dragRef.value) state.isOverOthers = false;
      else if (!state.isOverOthers) {
        state.overInput = false;
        state.isDraggedOver = false;
      }
    };

    const dropImage = (e) => {
      e.preventDefault();
      inputRef.value.files = e.dataTransfer.files;
      onFileChange();
      state.overInput = false;
    };

    const onPickFile = () => {
      inputRef.value.click();
    };

    const addressCardano = computed(
      () => store.getters["contracts/getAddressCardano"]
    );

    return {
      meta,
      value,
      state,
      dragRef,
      inputRef,
      hasSigned,
      dropImage,
      onPickFile,
      onDragOver,
      onDragLeave,
      onFileChange,
      errorMessage,
      loginOrSignUpCardano,
      addressCardano,
      isValidNetwork,
      isFileSelected,
      previewMessage,
      showErrorMessage,
      acceptedMimeTypes,
      isBeginConnectionModalOpen,
    };
  },
};
</script>
<style lang="scss" scoped src="@/Common/Styles/fileInput.scss"></style>
